<div *ngIf="type=='enable'">
    <mm-table class="mb-0" [values]="tableDataEnable" [columnNames]="columnNamesEnable" [tableSize]="scrollSize">
    </mm-table>
</div>

<div *ngIf="type=='view'">
    <mm-table [values]="tableDataView" [columnNames]="columnNames" [tableSize]="scrollSize">
    </mm-table>
</div>
